import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {renderMarkdown, getText} from 'helpers/text-helper';
import {themesData} from 'data/themes-data';
import GameProgress from 'components/ui/game-progress/game-progress';
import Button from 'components/ui/button/button';
import './game-experiment.scss';

const GameExperiment = ({languageId, deviceInfo, gameData, goToPage}) => {
	const [microActionId, setMicroActionId] = useState(null);

	/* Get micro actions for theme */
	const themeId = (gameData.themeId ? gameData.themeId : 'theme-1-1');
	const themeData = themesData.find((t) => {return t.id === themeId;});
	const microActions = (themeData && themeData.microActions ? themeData.microActions : []);

	const selectedMicroAction = microActions.find((m) => {return m.id === microActionId;});



	return (
		<div className={'GameExperiment ' + deviceInfo.orientation}>

			{/* Home btn */}
			<div className="GameExperiment-homeBtn" onClick={() => {goToPage('settings');}} />
			
			{/* Content */}
			<div className="GameExperiment-content">
				{/* Game progress */}
				<GameProgress 
					languageId={languageId}
					progressStepId={'results'}
					deviceInfo={deviceInfo}
				/>
				<div className="GameExperiment-title">
					<span>{(getText('pages_experimentsTitle', languageId))}</span>
				</div>

				<div className="GameExperiment-text">
					{renderMarkdown(getText('pages_experimentsText', languageId))}
				</div>
				<div className="GameExperiment-actions">
					{microActions.map((action, index) => {
						return (
							<div key={index} className="GameExperiment-action faded">
								<div className="GameExperiment-actionTitle">
									<span>{getText(action.title, languageId)}</span>
										
								</div>
								<div className="GameExperiment-actionShortText">
									<span>{getText(action.shortText, languageId)}</span>
								</div>
								<div 
									className="GameExperiment-infoBtn"
									onMouseOver={() => {setMicroActionId(action.id);}}
									onMouseLeave={() => {setMicroActionId(null);}}
								>
									<span>i</span>
								</div>
							</div>
						);
					})}

				</div>
				{selectedMicroAction && <div className="GameExperiment-actionInfo">
					{renderMarkdown(getText(selectedMicroAction.text, languageId))}
				</div>}
			</div>

			<div className="GameExperiment-backBtn">
				<Button 
					classes={['orange', 'fullHeight']}
					text={getText('general_back', languageId)}
					onClick={() => {goToPage('game-results-outro');}}
				/>
			</div>
			<div className="GameExperiment-nextBtn">
				<Button 
					classes={['orange', 'next', 'fullHeight']}
					text={getText('general_next', languageId)}
					onClick={() => {goToPage('game-experiment-presentation');}}
				/>
			</div>
		</div>
	);
};

GameExperiment.propTypes = {
	languageId: PropTypes.string.isRequired,
	deviceInfo: PropTypes.object.isRequired,
	gameData: PropTypes.object.isRequired,
	goToPage: PropTypes.func.isRequired
};

export default GameExperiment;